(function(){
  'use strict';
  var root=document.querySelector('[data-bb-header]');
  if(!root)return;

  var drawer=root.querySelector('[data-bb-drawer]');
  var openBtn=root.querySelector('[data-bb-open]');
  var closeBtn=root.querySelector('[data-bb-close]');
  var lastFocus=null;

  function lock(on){document.documentElement.style.overflow=on?'hidden':'';}

  function openDrawer(){
    lastFocus=document.activeElement;
    drawer.hidden=false;
    requestAnimationFrame(function(){drawer.classList.add('is-open');});
    openBtn.setAttribute('aria-expanded','true');
    lock(true);
    var f=drawer.querySelector('button,a,[tabindex]');
    if(f)f.focus();
  }
  function closeDrawer(){
    drawer.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded','false');
    lock(false);
    resetPanels();
    setTimeout(function(){drawer.hidden=true;},280);
    if(lastFocus)lastFocus.focus();
  }
  function resetPanels(){
    drawer.querySelectorAll('.bb-drawer__panel.is-active').forEach(function(p){p.classList.remove('is-active');});
    drawer.classList.remove('is-nested');
  }

  if(openBtn)openBtn.addEventListener('click',openDrawer);
  if(closeBtn)closeBtn.addEventListener('click',closeDrawer);

  drawer&&drawer.addEventListener('click',function(e){
    var toPanel=e.target.closest('[data-bb-to]');
    if(toPanel){
      e.preventDefault();
      var p=drawer.querySelector('#'+toPanel.getAttribute('data-bb-to'));
      if(p){p.classList.add('is-active');drawer.classList.add('is-nested');var h=p.querySelector('[data-bb-back]');if(h)h.focus();}
      return;
    }
    var back=e.target.closest('[data-bb-back]');
    if(back){
      e.preventDefault();
      var panel=back.closest('.bb-drawer__panel');
      if(panel)panel.classList.remove('is-active');
      if(!drawer.querySelector('.bb-drawer__panel.is-active'))drawer.classList.remove('is-nested');
      return;
    }
    if(e.target.hasAttribute('data-bb-scrim')){closeDrawer();}
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      if(drawer&&!drawer.hidden)closeDrawer();
      var open=root.querySelector('[data-bb-mega].is-open');
      if(open){open.classList.remove('is-open');var t=root.querySelector('[data-bb-mega-trigger][aria-expanded="true"]');if(t){t.setAttribute('aria-expanded','false');t.focus();}}
    }
  });

  var triggers=root.querySelectorAll('[data-bb-mega-trigger]');
  var hideTimer=null;
  function closeAllMega(){
    root.querySelectorAll('[data-bb-mega]').forEach(function(m){m.classList.remove('is-open');});
    triggers.forEach(function(t){t.setAttribute('aria-expanded','false');});
  }
  triggers.forEach(function(t){
    var id=t.getAttribute('data-bb-mega-trigger');
    var mega=root.querySelector('[data-bb-mega="'+id+'"]');
    if(!mega)return;
    function show(){clearTimeout(hideTimer);closeAllMega();mega.classList.add('is-open');t.setAttribute('aria-expanded','true');}
    function hide(){hideTimer=setTimeout(function(){mega.classList.remove('is-open');t.setAttribute('aria-expanded','false');},160);}
    t.addEventListener('mouseenter',show);
    t.addEventListener('focus',show);
    t.addEventListener('mouseleave',hide);
    mega.addEventListener('mouseenter',function(){clearTimeout(hideTimer);});
    mega.addEventListener('mouseleave',hide);
    t.addEventListener('click',function(e){
      if(window.matchMedia('(min-width:990px)').matches){
        e.preventDefault();
        if(mega.classList.contains('is-open')){closeAllMega();}else{show();}
      }
    });
  });
  document.addEventListener('click',function(e){if(!root.contains(e.target))closeAllMega();});

  var searchBtn=root.querySelector('[data-bb-search-open]');
  var searchOv=root.querySelector('[data-bb-search]');
  if(searchBtn&&searchOv){
    searchBtn.addEventListener('click',function(){
      searchOv.hidden=false;
      requestAnimationFrame(function(){searchOv.classList.add('is-open');});
      lock(true);
      var i=searchOv.querySelector('input');if(i)i.focus();
    });
    searchOv.addEventListener('click',function(e){
      if(e.target.hasAttribute('data-bb-search-close')||e.target.closest('[data-bb-search-close]')){
        searchOv.classList.remove('is-open');lock(false);
        setTimeout(function(){searchOv.hidden=true;},240);
      }
    });
  }

  var last=window.scrollY,threshold=120;
  window.addEventListener('scroll',function(){
    var y=window.scrollY;
    root.classList.toggle('is-stuck',y>8);
    if(y>threshold&&y>last){root.classList.add('is-hidden');}else{root.classList.remove('is-hidden');}
    last=y;
  },{passive:true});
})();
